// extracted by mini-css-extract-plugin
module.exports = {"bt85mh6":"bt85mh6","tcyd78g":"tcyd78g"};